import { useState, useCallback } from 'react';

export const useOutboundNumberSelectorView = () => {
  const [view, setView] = useState<'active-conversations' | 'all-numbers' | 'all-locations'>('active-conversations');

  const initializeView = useCallback((hasActiveConversation: boolean, isMultiLocation: boolean) => {
    if (hasActiveConversation) {
      setView('active-conversations');
    } else {
      if (isMultiLocation) {
        setView('all-locations');
      } else {
        setView('all-numbers');
      }
    }
  }, []);

  return {
    initializeView,
    setView,
    view,
  };
};
